/**
 * Derived on the server, so the client's query key never changes: one that changed 288 times a day re-suspended
 * the counters (TEC-3832) and left entries that refetched as one 16 KB GET (TEC-3807, TEC-3810). DR-28.
 */

const WINDOW_MS = 5 * 60_000;

export function currentWindowKey(): string {
	const windowStart = Math.floor(Date.now() / WINDOW_MS) * WINDOW_MS;
	return new Date(windowStart).toISOString().slice(0, 16);
}

/** The server hands out six minutes per five-minute window, so each refetch arrives with a minute in hand. */
export const WINDOW_REFETCH_MS = WINDOW_MS;
